import { TServiceCookie } from '../types/service-cookie.type';

type TProps = {
  parsedServicesFromCookies: TServiceCookie[];
  productCode: string;
  tintServiceIds: string[];
};

export const getTintServicesFromCookies = ({
  parsedServicesFromCookies,
  productCode,
  tintServiceIds,
}: TProps) =>
  parsedServicesFromCookies.filter(
    service =>
      service.parentLineId === productCode &&
      tintServiceIds.includes(service.id.toString()) &&
      'hex' in service &&
      !!service.hex &&
      'color' in service.parameters &&
      !!service.parameters.color
  );
